module.exports = __webpack_public_path__ + "img/error-dark.cc29d738.svg";